module.exports = __webpack_public_path__ + "img/letter.e4ea5058.png";